export const AD_SEGMENTS = [
  { value: "MARKET", label: "Mercado" },
  { value: "PETS", label: "Pets" },
  { value: "HANDICRAFTS", label: "Artesanatos" },
  { value: "SERVICES", label: "Serviços" },
] as const;

export type AdSegment = (typeof AD_SEGMENTS)[number]["value"];

export function getAdSegmentLabel(segment: AdSegment | null): string {
  return AD_SEGMENTS.find((option) => option.value === segment)?.label ?? "Não classificado";
}
